import { apiFetch, apiJson } from './api';
import type { StoryStatus } from './storyStatus';

export type StoryHeroThumb = {
  id: number;
  name: string;
  photo: string;
};

export type StoryListItem = {
  id: number;
  title: string;
  synopsis: string;
  status: StoryStatus;
  error_message: string;
  art_style: string;
  age_group: string;
  mood: string;
  genre: string;
  created_at: string;
  heroes: StoryHeroThumb[];
};

export type Option = { value: string; label: string };

export type StoryOptions = {
  art_styles: Option[];
  age_groups: Option[];
  moods: Option[];
  genres: Option[];
};

export type CreateStoryPayload = {
  prompt: string;
  art_style: string;
  age_group: string;
  mood: string;
  genre: string;
  hero_ids: number[];
};

export type StoryStatusOut = {
  id: number;
  status: StoryStatus;
};

export function listStories(statusFilter?: string): Promise<StoryListItem[]> {
  const qs = statusFilter ? `?status=${encodeURIComponent(statusFilter)}` : '';
  return apiJson<StoryListItem[]>(`/api/stories/${qs}`);
}

export function fetchStoryOptions(): Promise<StoryOptions> {
  return apiJson<StoryOptions>('/api/stories/options/');
}

export function createStory(payload: CreateStoryPayload): Promise<StoryStatusOut> {
  return apiJson<StoryStatusOut>('/api/stories/', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function contactSupport(errorCode: string, message?: string): Promise<void> {
  await apiFetch('/api/stories/contact-support/', {
    method: 'POST',
    body: JSON.stringify({ error_code: errorCode, message: message ?? null }),
  });
}

export type ImageField = {
  url: string | null;
  prompt?: string | null;
  error?: string | null;
};

export type Scene = {
  id: number;
  number: number;
  setting: string;
  description: string;
  visual_description: string;
  composed_image: ImageField | null;
  book_text: string;
  palette: string[] | null;
};

export type Story = {
  id: number;
  title: string;
  synopsis: string;
  status: StoryStatus;
  error_message: string;
  language: string;
  page_aspect: string;
  scenes: Scene[];
  front_cover: ImageField | null;
  back_cover: ImageField | null;
  created_at: string;
};

export function getStory(id: number): Promise<Story> {
  return apiJson<Story>(`/api/stories/${id}/`);
}
